// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__L4tD1","logo":"Footer_logo__qVJF6","menu":"Footer_menu__uFqDS","other":"Footer_other__1Ephb","icons":"Footer_icons__2zaLh"};